/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import TimeZoneConnected from '../../components/Common/TimeZone';

export const StyledTimeZone = styled(TimeZoneConnected)`
  margin-top: 10px;
  text-align: left;
`;
